/**
 * Import Lib & assets
 */

import React, { useState, useEffect } from "react";
import styled from "styled-components";
import PropTypes from "prop-types";
import t from "theme";

/**
 * import components
 */

/**
 * styled components
 */

const Container = styled.div`
  ${t.mixins.flex({ justify: "flex-start" })}
  padding: 9px 0;
  cursor: pointer;
  ${t.mixins.rem(18, 24)}
  font-family: ${t.font.primary};
  color: ${t.color.darkGrey};
  ${t.mixins.sm(`
    ${t.mixins.rem(13, 15)}
  `)}
`;
const Button = styled.button`
  min-height: 22px;
  min-width: 22px;
  margin-right: 22px;
  border-radius: 50%;
  border: solid 1px ${t.color.darkGrey};
  cursor: pointer;

  ${t.mixins.sm(`
    min-height: 19px;
    min-width: 19px;
    margin-right: 8px;
  `)}

  ${({ selected }) =>
    selected &&
    `
    background-color: ${t.color.secondary}
    border: none;

  `}
`;
const Label = styled.p`
  max-width: 210px;
`;

/**
 * radio component is..
 */

const Button__radio = ({ title, onClick, selected = undefined, className }) => {
  return (
    <Container onClick={onClick} className={className}>
      <Button selected={selected} />
      <Label>{title}</Label>
    </Container>
  );
};

export default Button__radio;

Button__radio.propTypes = {
  /**
      Function to trigger when new radio selected
      */
};
